module.exports = __webpack_public_path__ + "static/sec3-leaves-1e316a6d5968f2b2a30d79f5dc59323c.png";